import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import CommonStepBar from "components/common/CommonStepBar"
import CommonTitle from "components/common/CommonTitle"
import Layout from "components/Layout/Layout"
import { Container, Alert, Box } from "@mui/material"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import { isTypeAQR2, isTypeAQR3, isTypeAQR5, isTypeKQR4, isTypeKQR5, QrCheck } from "utils/QrChecks"
import { BrowserQRCodeReader } from "@zxing/browser"
import {
  QRCodeMultiReader,
  MultipleBarcodeReader,
  BinaryBitmap,
  Result,
  DecodeHintType,
  BarcodeFormat
} from "@zxing/library"
import { planActions } from "store/actions/PlanAction"
import { qrActions } from "store/actions/QRAction"
import { userInfoActions } from "store/actions/UserInfoAction"
import GoBackButton from "components/Button/GoBackButton"
import { useDispatch } from "react-redux"
import { useDropzone } from "react-dropzone"
import { APP_URL } from "Const"
import shakenSampleKei from "images/shaken-sample-kei.jpg"
import shakenSample from "images/shaken-sample.jpg"
import styles from "./Upload.module.scss"

/**
 * Step1 車検証読取画面（アップロード）
 * アップロードされた車検証をZxingで読み取る
 * 読み取りが成功した場合、Step2車情報入力画面に遷移
 */
const Upload = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [files, setFiles] = useState<File[]>([])
  const [src, setSrc] = useState("")
  const [load, setLoad] = useState(false)
  const [scan, setScan] = useState(false)
  const [error, setError] = useState(false)
  const [alert, setAlert] = useState(false)
  const [reject, setReject] = useState("")
  const [key, setKey] = useState(0)

  const [typeAResult2, setTypeAResult2] = useState("")
  const [typeAResult3, setTypeAResult3] = useState("")
  const [typeAResult5, setTypeAResult5] = useState("")
  const [typeKResult4, setTypeKResult4] = useState("")
  const [typeKResult5, setTypeKResult5] = useState("")

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop: (acceptedFiles: File[]) => {
      setFiles(acceptedFiles)
      setError(false)
      setReject("")
    },
    accept: {
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"],
      "image/bmp": [".bmp"]
    },
    maxSize: 10485760,
    maxFiles: 1,
    onDropRejected: (fileRejections) => {
      setFiles([])
      setError(false)
      const rejection = fileRejections[0]
      if (rejection) {
        setReject(
          rejection.file.size > 10485760
            ? "画像のサイズが上限（10MB）を超えています。"
            : "ご利用可能な画像形式ではありません。"
        )
      }
    }
  })

  useEffect(() => {
    dispatch(planActions.reset())
    dispatch(qrActions.reset())
    dispatch(userInfoActions.reset())
  }, [])

  useEffect(() => {
    setKey(key + 1)
    if (scan) {
      console.info(typeAResult2)
      console.info(typeAResult3)
      console.info(typeAResult5)
      console.info(typeKResult4)
      console.info(typeKResult5)
      if ((typeAResult2 && typeAResult3 && typeAResult5) || (typeKResult4 && typeKResult5)) {
        setAlert(true)
        const { vehicleType, carModel, firstInspectionYear, firstInspectionMonth } = QrCheck(
          typeAResult2,
          typeAResult3,
          typeAResult5,
          typeKResult4,
          typeKResult5
        )

        // 用途車種が取得できない場合は見積もり対象外エラー
        if (!vehicleType) {
          navigate(APP_URL.ERROR, {
            state: { isNotCovered: true }
          })
          return
        }

        dispatch(qrActions.updateVehicleType(vehicleType)) // 用途車種
        dispatch(qrActions.updateCarModel(carModel)) // 型式
        dispatch(qrActions.updateFirstInspectionYear(firstInspectionYear)) // 初度登録年
        dispatch(qrActions.updateFirstInspectionMonth(firstInspectionMonth)) // 初度登録月
        dispatch(qrActions.updateIsScan(true)) // スキャンフラグ
        setTimeout(() => {
          navigate(APP_URL.RESULT)
        }, 1000)
      } else {
        setFiles([])
        setKey(0)
        setScan(false)
        setError(true)
        setReject("")
      }
    }
  }, [scan])

  useEffect(() => {
    if (files.length) {
      setSrc(URL.createObjectURL(files[0]))
    } else {
      setSrc("")
    }
  }, [files])

  useEffect(() => {
    if (load) {
      setLoad(false)
      setError(false)
      setReject("")
      try {
        const img = BrowserQRCodeReader.getMediaElement("img", "img")
        const bitmap: BinaryBitmap = BrowserQRCodeReader.createBinaryBitmapFromMediaElem(img)
        const qrCodeMultiReader: MultipleBarcodeReader = new QRCodeMultiReader()
        // 精度、速度向上のためのhintsを追加
        const hints = new Map()
        const formats = [BarcodeFormat.QR_CODE]
        hints.set(DecodeHintType.POSSIBLE_FORMATS, formats)
        hints.set(DecodeHintType.TRY_HARDER, true)
        // QRコード画像を一括でdecode
        const results: Result[] = qrCodeMultiReader.decodeMultiple(bitmap, hints)
        if (results && results.length) {
          results.forEach((r) => {
            console.info(r)
            if (isTypeAQR2(r.getText())) {
              console.info(`atype qr2 === ${r.getText()}`)
              setTypeAResult2(r.getText())
            }
            if (isTypeAQR3(r.getText())) {
              console.info(`atype qr3 === ${r.getText()}`)
              setTypeAResult3(r.getText())
            }
            if (isTypeAQR5(r.getText())) {
              console.info(`atype qr5 === ${r.getText()}`)
              setTypeAResult5(r.getText())
            }
            if (isTypeKQR4(r.getText())) {
              console.info(`ktype qr4 === ${r.getText()}`)
              setTypeKResult4(r.getText())
            }
            if (isTypeKQR5(r.getText())) {
              console.info(`ktype qr5 === ${r.getText()}`)
              setTypeKResult5(r.getText())
            }
          })
          setScan(true)
          setError(false)
          setReject("")
        }
      } catch (err) {
        setFiles([])
        setKey(0)
        setError(true)
        console.log(err)
      }
    }
  }, [load])

  const rootProps = getRootProps()
  const inputProps = getInputProps()

  const getDropzoneClassName = () => {
    if (!isDragActive) {
      return styles.dropzoneBase
    }
    if (isDragReject) {
      return styles.dropzoneReject
    }
    return styles.dropzoneActive
  }

  return (
    <Layout>
      <Container maxWidth="md" className={styles.root}>
        <CommonStepBar num={1} />
        <CommonTitle titles={["車検証を読み取る"]} read="すべての二次元バーコードが写っている画像をご用意ください。" />
        <hr />
        <div className={styles.file}>
          <div className={styles.alert}>
            {alert && <Alert severity="success">読み取りが完了しました。</Alert>}
            {error && <Alert severity="error">お車の情報が読み取れませんでした。</Alert>}
            {reject && <Alert severity="error">{reject}</Alert>}
          </div>
          <div className={styles.dropzoneArea}>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
            <div
              onClick={rootProps.onClick}
              onDragEnter={rootProps.onDragEnter}
              onDragOver={rootProps.onDragOver}
              onDragLeave={rootProps.onDragLeave}
              onDrop={rootProps.onDrop}
              tabIndex={rootProps.tabIndex}
              role={rootProps.role}
              className={getDropzoneClassName()}
            >
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <input {...inputProps} />
              <div>
                <CloudUploadIcon />
              </div>
              <span className={styles.dropzoneText}>こちらに車検証の画像をドラッグしてください</span>
            </div>
            <div className={styles.help}>
              <span>ご利用可能な画像形式：JPEG、PNG、BMP</span>
              <span>ファイルサイズの上限：10MB</span>
              <br />
            </div>
          </div>
        </div>

        <div className={styles.next}>
          <span>読み取り完了後、画面が自動的に次のステップへ遷移します。</span>
          <span>
            お車の情報を手動で入力する場合、
            <a
              className={styles.link2next}
              href="/car"
              onClick={() => {
                // ストアの初期化
                dispatch(planActions.reset())
                dispatch(qrActions.reset())
                dispatch(userInfoActions.reset())
              }}
            >
              こちら
            </a>
            をクリックしてください。
          </span>
        </div>

        <div className={styles.refer}>
          <span>車検証の二次元バーコードの箇所は下図をご参考ください。</span>
        </div>

        <div className={styles.footer}>
          <div className={styles.images}>
            <div className={styles.image}>
              <img src={shakenSample} alt="普通自動車" />
              <span>普通自動車の場合</span>
            </div>
            <div className={styles.image}>
              <img src={shakenSampleKei} alt="軽自動車" />
              <span>軽自動車の場合</span>
            </div>
          </div>
        </div>
        <img id="img" src={src} alt="" onLoad={() => setLoad(true)} style={{ display: "none" }} />
        <GoBackButton top />
      </Container>
    </Layout>
  )
}

export default Upload
